import gql from "graphql-tag";
import UserSettings from "../fragments/UserSettings";

export default gql`
  mutation CloseNomadPartnership {
    closeNomadPartnership {
      _id
      ...UserSettings
    }
  }

  ${UserSettings}
`;
